import MoneyUtils from './moneyUtils';

/**
 * Format the discount label shown on a promotion card.
 * e.g. "15% OFF" or "₹50 Flat Off"
 */
export const formatPromoLabel = (promo) => {
  if (!promo) return '';
  if (promo.discountType === 'flat') {
    return `${MoneyUtils.format(promo.discountValue)} Flat Off`;
  }
  const rate = promo.discountValue || promo.discountPercentage || 0;
  return `${rate}% OFF`;
};

/**
 * Calculate the discount amount in smallest unit from a promotion.
 * @param {number} itemTotalSmallest - item total in smallest unit
 * @param {object} promo - promotion object
 * @returns {number} discount amount in smallest unit
 */
export const calcPromoDiscount = (itemTotalSmallest, promo) => {
  if (!promo) return 0;
  const minOrder = promo.minOrderAmount || 0;
  if (minOrder > 0 && itemTotalSmallest < minOrder) return 0;

  if (promo.discountType === 'flat') {
    return Math.min(promo.discountValue || 0, itemTotalSmallest);
  }
  const rate = promo.discountValue || promo.discountPercentage || 0;
  return Math.round(itemTotalSmallest * (rate / 100));
};
